// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__233u2","alertIcon":"ConfirmModal_alertIcon__7QiHO"};